import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJiraLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 36 36",
	fill: "none",
	width: "1em",
	height: "1em",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M34.068 0.934036H17.1821C17.1821 2.95566 17.9852 4.89448 19.4147 6.32399C20.8442 7.75349 22.783 8.55658 24.8047 8.55658H27.9152V11.5599C27.918 15.7659 31.3269 19.1749 35.5328 19.1776V2.39889C35.5328 1.5901 34.8772 0.934036 34.068 0.934036Z",
			fill: "#2684FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7129 9.34756H8.82715C8.82976 13.5535 12.2386 16.9626 16.4447 16.9653H19.5553V19.9782C19.5607 24.1842 22.9719 27.5909 27.1779 27.5909V10.8127C27.1779 10.0036 26.5219 9.3477 25.7129 9.3477V9.34756Z",
			fill: "#2684FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3529 17.7563H0.467041C0.467041 21.9661 3.87989 25.3788 8.08958 25.3788H11.2099V28.382C11.2127 32.5842 14.6156 35.9917 18.8179 35.9996V19.2213C18.8179 18.4122 18.162 17.7563 17.3529 17.7563Z",
			fill: "#2684FF"
		})
	] })]
});
const ForwardRef = forwardRef(SvgJiraLogo);
export { ForwardRef as ReactComponent };
